/**
 * Checks to see if a given url is an external link by checking if there's a leading `http`
 *  protocol.
 *
 * @param {string} url The url to check.
 *
 * @return boolean
 */
export default url => url.substr(0, 4) === "http"
